import React from "react";
import {Grid, Tooltip, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import {
    differenceInDays,
    differenceInHours, differenceInMinutes,
    format,
    formatDistance,
    formatRelative,
    intervalToDuration,
    parseISO,
    subDays
} from 'date-fns'
import {renderMilisecondsToTimeDuration} from "../../../utils/datetimehelp";
import {useDispatch, useSelector} from "react-redux";
import {convertISODateTimeToHHMMTz, convertISODateTimeToTz} from "../../../common/Util";
import {getThotAutoclavesMonitorTenant} from "../../../actions/thotActions";
import {useLocation} from "react-router-dom";
import {getRandomInt} from "../../../utils/utils";


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    areaOSKPI:{
      display: 'flex',
      alignContent: 'center',
      alignSelf: 'flex-start',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '5px',
      margin: '3px',
      flexDirection: 'column',
      flexWrap: 'nowrap',
    //    backgroundColor: 'cyan',
        minWidth: '100px'
    },
    areaReduzido:{
        display: 'flex',
        alignContent: 'center',
        alignSelf: 'flex-start',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '5px',
        margin: '3px',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        //    backgroundColor: 'cyan',
        minWidth: '100px'
    },
    shape: {
        display: 'inline-block',
        backgroundColor: 'blue', // theme.palette.primary.main,
        width: 10,
        height: 10,
    },
    shapeCircle: {
        borderRadius: '50%',
    },
    texto: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        flexGrow: 12,
        flexFlow: 'column',
        textAlign: 'center',
        justifyContent: "space-between"
    }
}));


const AutoclaveKPI = ({ autoclave, mostrarComm } ) => {
    const classes = useStyles();
    const uId =  useSelector(state => state.auth.userId);
    const demo = uId === 268;



    let autoclaveColor = 'black';
    let cicloColor = 'gray';

    let alarme = false;
    let cicloStatus= '';

    let semComunicacaoAutoclave = false;
    let semComunicacaoCloud = false;
    let semComunicacaoLongoTempo = false;



    var dultcom = parseISO(autoclave.DTUtc);
    if (autoclave.dtUltCom != null) { dultcom = parseISO(autoclave.dtUltCom); }

    var agora = new Date();

    if (autoclave.processoIniciado && !autoclave.fimDeCiclo && differenceInHours(agora, dultcom) > 1 ) { semComunicacaoCloud = true; }
    if (differenceInHours(agora, dultcom) > 6) { semComunicacaoCloud = true;}
    if ( differenceInDays(agora, dultcom) > 4 ) { semComunicacaoCloud = true; semComunicacaoLongoTempo = true; }
    if (differenceInMinutes(agora, dultcom) > 20) { semComunicacaoAutoclave = true;}


    if (autoclave.processoIniciado)  { cicloColor = 'green'; }

    if (autoclave.fimDeCiclo) { cicloColor = 'gray'; }
    if (alarme) { cicloColor = 'red';}


    let autoclaveBorderWidth = '1px';
    if (semComunicacaoCloud) {autoclaveColor = 'orange'; autoclaveBorderWidth = '3px';}
    if (semComunicacaoLongoTempo) { autoclaveColor = 'red'; autoclaveBorderWidth = '2px';}

    if (autoclave.alarmeSemComunicacao) { semComunicacaoAutoclave = true;  }

    let styKPI = {}




    try {

        const alarmeX =  ( alarm, descricao ) => {
            if (alarm) {

                return ( <React.Fragment>{descricao}<br/></React.Fragment> );
            }
        }




        cicloStatus = <span>
            PLANTA {autoclave.estabelecimentoId} AUTOCLAVE {autoclave.codigo} ({autoclave.capacidade} PNEUS)<br/>
            IDENTIFICACAO INTERNA I4: {autoclave.aId}<br/><br/>

            {(autoclave.processoIniciado && !autoclave.fimDeCiclo)? `AUTOCLAVE EM CICLO. ` :
                (autoclave.fimDeCiclo? `AUTOCLAVE PARADA.` : '')}<br/><br/>

            ULTIMA COMUNICACAO:<br/>
            AUTOCLAVE {convertISODateTimeToHHMMTz(autoclave.dtUltCom)}<br/>
            EM CICLO {convertISODateTimeToHHMMTz(autoclave.DTUtc)}<br/><br/>

            TIPO DE ESTABELECIMENTO {autoclave.estabelecimentoTipoId}<br/><br/>
            LICENCA DE CICLOS: {(autoclave.licencaNumCiclosLiberados === null)? 'N/A' : autoclave.licencaNumCiclosLiberados }<br/><br/>
            SGV VERSAO: {autoclave.sgvVersao} <br/><br/>

            NUMERO DE CICLOS REALIZADOS NO MES:<br/>
            ATUAL: {demo? getRandomInt(10,200) : autoclave.numCiclos}<br/>
            PASSADO: { demo? getRandomInt(10,200) : autoclave.numCiclosMesPassado} <br/><br/>


             TEMP AUTOCLAVE:{autoclave.efetivoTemperatura}C<br/>
             PRESSAO AUTOCLAVE:{autoclave.efetivoPressao}<br/>
             PRESSAO ENVELOPE:{autoclave.efetivoPressaoEnvelope}<br/><br/>


            { alarmeX(autoclave.alarmeSemComunicacao, 'SEM COMUNICACAO COM AUTOCLAVE')}
            { alarmeX(semComunicacaoCloud, 'SEM COMUNICACAO CLOUD + 6 HORAS OU 1H SE EM CICLO')}
            { alarmeX(semComunicacaoLongoTempo, 'SEM COMUNICACAO CLOUD + 4 DIAS')}<br/>

            { alarmeX(autoclave.alarmeEmergencia, 'ALARME DE EMERGENCIA')}
            { alarmeX(autoclave.alarmeVentilador, 'ALARME VENTILADOR')}
            { alarmeX(autoclave.alarmePT100, 'ALARME PT100')}
            {alarmeX(autoclave.alarmeSupervisaoPressaoAutoclave, `ALARME SUPERVISAO PRESSAO AUTOCLAVE`)}
            {alarmeX(autoclave.alarmeSupervisaoAquecimento, `ALARME SUPERVISAO AQUECIMENTO`)}
            {alarmeX(autoclave.alarmeTemperaturaBaixa, `ALARME TEMPERATURA BAIXA`)}
            {alarmeX(autoclave.alarmeTemperaturaAlta, `ALARME TEMPERATURA ALTA`)}
            {alarmeX(autoclave.alarmePressaoAlta, `ALARME PRESSAO ALTA`)}
            {alarmeX(autoclave.alarmePressaoAltaSacoDeAr, `ALARME PRESSAO ALTA SACO DE AR`)}
            {alarmeX(autoclave.alarmePressaoAltaEnvelope, `ALARME PRESSAO ALTA ENVELOPE`)}
            {alarmeX(autoclave.alarmePressaoBaixa, `ALARME PRESSAO BAIXA`)}
            {alarmeX(autoclave.alarmePressaoBaixaSacoDeAr, `ALARME PRESSAO BAIXA SACO DE AR`)}
            {alarmeX(autoclave.alarmePressaoBaixaEnvelope, `ALARME PRESSAO BAIXA ENVELOPE`)}
            {alarmeX(autoclave.alarmeFalhaAcionamentoVentilador, `ALARME FALHA ACIONAMENTO VENTILADOR`)}
            {alarmeX(autoclave.alarmeTripAquecimento, `ALARME TRIP AQUECIMENTO`)}
            {alarmeX(autoclave.alarmeTripPressao, `ALARME TRIP PRESSAO`)}
            {alarmeX(autoclave.alarmeTripPressaoSacoDeAr, `ALARME TRIP PRESSAO SACO DE AR`)}
            {alarmeX(autoclave.alarmeTripPressaoEnvelope, `ALARME TRIP PRESSAO ENVELOPE`)}
            {alarmeX(autoclave.alarmeTripTemperatura, `ALARME TRIP TEMPERATURA`)}
            {alarmeX(autoclave.alarmeTripTemperaturaSacoDeAr, `ALARME TRIP TEMPERATURA SACO DE AR`)}
            {alarmeX(autoclave.alarmeTripTemperaturaEnvelope, `ALARME TRIP TEMPERATURA ENVELOPE`)}
            {alarmeX(autoclave.alarmeTripPressaoAutoclave, `ALARME TRIP PRESSAO AUTOCLAVE`)}
            {alarmeX(autoclave.alarmeTripAquecimentoAutoclave, `ALARME TRIP AQUECIMENTO AUTOCLAVE`)}
            {alarmeX(autoclave.alarmeTripPressaoSacoDeArAutoclave, `ALARME TRIP PRESSAO SACO DE AR AUTOCLAVE`)}
            {alarmeX(autoclave.alarmeTripPressaoEnvelopeAutoclave, `ALARME TRIP PRESSAO ENVELOPE AUTOCLAVE`)}
            {alarmeX(autoclave.alarmeTripTemperaturaAutoclave, `ALARME TRIP TEMPERATURA AUTOCLAVE`)}
            {alarmeX(autoclave.alarmeTripTemperaturaSacoDeArAutoclave, `ALARME TRIP TEMPERATURA SACO DE AR AUTOCLAVE`)}
            {alarmeX(autoclave.alarmeTripTemperaturaEnvelopeAutoclave, `ALARME TRIP TEMPERATURA ENVELOPE AUTOCLAVE`)}
            {alarmeX(autoclave.alarmeBateriaCLP, `ALARME BATERIA CLP`)}
            {alarmeX(autoclave.alarmeDescargaSacoDeAr, `ALARME DESCARGA SACO DE AR`)}
            {alarmeX(autoclave.alarmeDescargaEnvelope, `ALARME DESCARGA ENVELOPE`)}
            {alarmeX(autoclave.alarmePortaAutoclaveAberta, `ALARME PORTA ABERTA`)}
            {alarmeX(autoclave.alarmePressostato, `ALARME PRESSOSTATO`)}
            {alarmeX(autoclave.alarmeTermostato, `ALARME TERMOSTATO`)}
            {alarmeX(autoclave.alarmeFalhaRetornoContactoraAquecimento, `ALARME FALHA CONTACTORA AQUECIMENTO`)}
            {alarmeX(autoclave.alarmeFaltaEnergia, `ALARME FALTA DE ENERGIA`)}
            {alarmeX(autoclave.alarmeRiscoIncendio, `ALARME RISCO DE INCENDIO`)}
            {alarmeX(autoclave.alarmePressaoOscilou, `ALARME PRESSAO OSCILOU`)}
            <br/>


        </span>;


    } catch (e) {
        console.log("TRY CATCH ERROR");
        console.log(e);
    }



    //if (semComunicacaoCloud) { styKPI = { backgroundColor: 'red' }; }

    return (
        <React.Fragment>
            <Tooltip title={cicloStatus}>
                <div>
                {mostrarComm &&
                  <Grid container id={`Grid-AutoclaveKPI${autoclave.codigo}`} className={classes.areaOSKPI} style={ {...styKPI, minWidth: '125px', padding:'2px', borderColor: autoclaveColor,borderWidth: autoclaveBorderWidth }} item >

                        <Grid item className={classes.texto} >
                            <Typography variant="caption">AC:</Typography>
                            <Typography variant="caption">{autoclave.estabelecimentoId}-{autoclave.codigo}</Typography>
                            <Typography variant="caption">({autoclave.capacidade}P)</Typography>
                        </Grid>

                      <Grid item className={classes.texto} md={12} xl={12} lg={12}>
                          <Typography variant="caption">#CICLOS MES</Typography>
                      </Grid>
                      <Grid container item style={{ display:'flex', justifyContent: 'space-around'}}>
                          <Grid item className={classes.texto} md={12} xl={12} lg={12}>
                              <Typography variant="caption">ATUAL</Typography>
                              <Typography variant="caption">{ demo? getRandomInt(10,200) : autoclave.numCiclos}</Typography>
                              {/*<Typography variant="overline">/{valor2}</Typography>*/}
                          </Grid>

                          <Grid item className={classes.texto} md={12} xl={12} lg={12}>
                              <Typography variant="caption">ANTERIOR</Typography>
                              <Typography variant="caption">{ demo? getRandomInt(10,200) : autoclave.numCiclosMesPassado}</Typography>
                              {/*<Typography variant="overline">/{valor2}</Typography>*/}
                          </Grid>

                      </Grid>


                        <Grid item className={classes.texto}>
                            <Typography variant="caption">COM:</Typography>
                            <Typography variant="caption">{autoclave.dtUltCom? format(parseISO(autoclave.dtUltCom),"dd/MM/yy HH:mm"): ""}</Typography>
                            {/*<Typography variant="overline">/{valor2}</Typography>*/}
                        </Grid>

                        <Grid item className={classes.texto} style={{flexWrap: 'nowrap'}}>
                            <Typography variant="caption">CIC:</Typography>
                            <Typography variant="caption">{autoclave.DTUtc? format(parseISO(autoclave.DTUtc),"dd/MM/yy HH:mm"): ""}</Typography>
                        </Grid>


                        <Grid item container className={classes.texto} style={{ backgroundColor: cicloColor, justifyContent: 'space-around' }}>
                            <Typography variant="caption">CICLO</Typography>
                            <Typography variant="caption">{autoclave.ciclo}</Typography>
                            {/*<Typography variant="overline">/{valor2}</Typography>*/}
                        </Grid>




                            <Grid item className={classes.texto} style={{flexWrap: 'nowrap', justifyContent: 'space-around'}}>
                                <Typography variant="caption"> TA:{autoclave.efetivoTemperatura}C</Typography>
                                <Typography variant="caption"> PA:{autoclave.efetivoPressao} </Typography>
                                <Typography variant="caption">  PE:{autoclave.efetivoPressaoEnvelope}</Typography>
                            </Grid>

                          { semComunicacaoAutoclave &&
                              <Grid item className={classes.texto} style={{backgroundColor: 'orange', justifyContent: 'center'}}>
                                  <Typography variant="caption">SEM COMUNICACAO</Typography>
                              </Grid>
                          }

                    </Grid>
                  }


                  { !mostrarComm &&
                      <Grid container id={`Grid-AutoclaveKPI${autoclave.codigo}`} className={classes.areaReduzido} style={ {...styKPI, minWidth: '125px',  borderColor: autoclaveColor,borderWidth: autoclaveBorderWidth}} item >

                             <Grid item className={classes.texto} >
                                 <Typography variant="caption">{autoclave.estabelecimentoId}-{autoclave.codigo}</Typography>
                             </Grid>
                              { semComunicacaoAutoclave &&
                                  <Grid item className={classes.texto} style={{backgroundColor: 'orange'}}>
                                      <Typography variant="caption">S/COM</Typography>
                                  </Grid>
                              }
                              <Grid item className={classes.texto} >
                                  <Typography variant="caption">{ demo? getRandomInt(10,200) : autoclave.numCiclos}</Typography>
                              </Grid>
                              <Grid item className={classes.texto} >
                                  <Typography variant="caption">{ demo? getRandomInt(10,200) :autoclave.numCiclosMesPassado}</Typography>

                              </Grid>

                      </Grid>
                  }

                </div>


            </Tooltip>

        </React.Fragment>
    );
}

export default AutoclaveKPI;
